import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../../../store/state/app.state';
import { userBalanceSelector } from '../../../../../store/selectors/billing.selectors';
import { combineLatest } from 'rxjs';
import { TicketInfoInterface } from '../../models/ticket-info.interface';

@Component({
  selector: 'app-multi-chat-navigation-card',
  templateUrl: './multi-chat-navigation-card.component.html',
  styleUrls: ['./multi-chat-navigation-card.component.scss'],
})
export class MultiChatNavigationCardComponent implements OnInit, OnChanges {
  @Input() ticket!: TicketInfoInterface;

  @Input() isTicketChosen: boolean = false;

  @Output() statusChanged: EventEmitter<any> = new EventEmitter<any>();

  private userBalance: number = 0;

  status = {
    lookingAnExpert: false,
    solvingYourTask: false,
    topUpCoins: false,
    checkSolution: false,
    waitingForReply: false,
    checkSolutionWithFeedback: false,
    reply: false,
    solved: false,
    openTask: false,
    checkMessage: false,
  };

  constructor(private store: Store<AppStateInterface>) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ticket?.currentValue) {
      this.ticket = changes.ticket.currentValue;
      this.checkTicketStatus();
    }
  }

  ngOnInit(): void {
    combineLatest([this.store.select(userBalanceSelector)]).subscribe(([userBalance]) => {
      this.userBalance = userBalance;
      this.checkTicketStatus();
    });
  }

  private checkTicketStatus() {
    this.resetStatus();
    if (
      this.ticket.status !== 'closed' &&
      !this.userBalance &&
      !this.ticket.is_charged_solution &&
      !this.ticket.ask_question
    )
      this.status.topUpCoins = true; // Тікет відкритий, треба докупити коінів ✅
    else if (
      this.ticket.status === 'opened' &&
      this.ticket.ticket_time_status === 'waiting_for_lock'
    )
      this.status.lookingAnExpert = true; // Пошук експерта ✅
    else if (
      this.ticket.status === 'locked' &&
      !this.ticket.is_charged_solution &&
      !this.ticket.ask_question &&
      this.ticket.ticket_time_status === 'waiting_for_solve'
    )
      this.status.solvingYourTask = true; // Тікет відкритий, йде розвязок ✅
    else if (
      this.ticket.status === 'locked' &&
      this.ticket.is_charged_solution &&
      !this.ticket.ask_question &&
      !this.ticket.need_confirm_close_unsolved_ticket &&
      !this.ticket.need_confirm_close_ticket
    )
      this.status.checkSolution = true; // Є рішення ✅
    else if (this.ticket.status !== 'closed' && this.ticket.ask_question)
      this.status.waitingForReply = true;
    // Тікет відкритий, але перевідкритий юзером для питання ✅
    else if (
      this.ticket.status === 'closed' &&
      this.ticket.is_charged_solution &&
      this.ticket.need_confirm_close_ticket
    )
      this.status.checkSolutionWithFeedback = true;
    // Тікет закритий, треба дати фідбек (звичайний з оцінкою тікета) ✅
    else if (this.ticket.status === 'closed' && this.ticket.need_confirm_close_unsolved_ticket)
      this.status.reply = true;
    // Тікет закритий, треба дати фідбек чи потрібно вирішувати цю таску (логіка ансолвед) ✅
    else if (
      this.ticket.status === 'closed' &&
      !this.ticket.need_confirm_close_ticket &&
      this.ticket.is_charged_solution
    )
      this.status.solved = true; // Тікет закритий, не треба давати фідбеків, у тікеті є рішення ✅
    else if (
      (this.ticket.status === 'closed' &&
        !this.ticket.need_confirm_close_ticket &&
        !this.ticket.is_charged_solution) ||
      this.ticket.fake_close
    )
      this.status.openTask = true;
    // Тікет закритий, не треба давати фідбеків, у тікеті нама рішення ✅
    else if (
      this.ticket.status === 'closed' &&
      this.ticket.fake_close &&
      !this.ticket.is_charged_solution
    )
      this.status.checkMessage = true; // Тікет знаходиться у статусі фейк закриття (24 години, якщо нема солюшену/коіну знятого) ✅

    this.statusChanged.emit();
  }

  private resetStatus() {
    const statuses = this.status;
    for (let field in this.status) {
      this.status[field as keyof typeof statuses] = false;
    }
  }

  errorHandler(event: any) {
    event.target.src =
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOzYl5mENdSh-2Y_Du5uLJFWWabrVUASKZVCwIbF31naD6ES1GHf2dppUm7BUA5ox52mk&usqp=CAU';
  }
}
